// lib
import React from 'react';

// components
import KnowMore from 'shared/layouts/DetailsPage/components/ProductInfo/Desktop/components/EcomPolicy/components/KnowMore';

// styles
import { Card, EcomPolicyImage, EcomPolicyText } from './styles';

// def
interface ICard {
  image: string;
  text: string;
  enable?: boolean;
  policyName: string;
  onClick: (enable: boolean, name: string) => void;
}

function EcomPolicyCard({ image, text, enable = false, policyName, onClick }: ICard) {
  return (
    <Card>
      <EcomPolicyImage src={image} alt="Cash on delivery" />

      <EcomPolicyText
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />

      {enable && (
        <KnowMore
          onClick={() => {
            onClick(enable, policyName);
          }}
        />
      )}
    </Card>
  );
}

export default EcomPolicyCard;
